<template>
    <b-overlay :show="getting" rounded opacity="1">
        <div class="p-1">
            <b-modal id="add-mediation-payment" title="Ödeme Ekle" no-close-on-esc no-close-on-backdrop>
                <div class="row">
                    <div class="col-md-6 mb-1">
                        <label class="form-label text-secondary">Ödeme Tarihi</label>
                        <v-date-picker placeholder="Ödeme Tarihi" v-model="payment.PaymentDate"></v-date-picker>
                    </div>
                    <div class="col-md-6 mb-1">
                        <label class="form-label text-secondary">Ödeme Tutarı</label>
                        <v-currency-input input-class="text-right" :value="payment.PaymentAmount" v-on:update-value="v => payment.PaymentAmount = v"></v-currency-input>
                    </div>
                    <div class="col-md-6 mb-1">
                        <label class="form-label text-secondary">Ödeme Yöntemi</label>
                        <select class="form-control" v-model="payment.PaymentMethod">
                            <option v-for="m in paymentMethods" :key="m.value" :value="m.value">{{ m.name }}</option>
                        </select>
                    </div>
                    <div class="col-md-6 mb-1" v-if="payment.PaymentMethod == 2">
                        <label class="form-label text-secondary">Çek Numarası <span class="text-danger">*</span></label>
                        <input class="form-control" v-model="payment.CheckNumber" placeholder="Çek Numarası"/>
                    </div>
                    <div class="col-md-6 mb-1">
                        <label class="form-label text-secondary">Referans Numarası</label>
                        <input class="form-control" v-model="payment.ReferenceNumber" placeholder="Referans Numarası"/>
                    </div>
                    <div class="col-12">
                        <label class="form-label text-secondary">Açıklama</label>
                        <textarea class="form-control resize-none" rows="2" v-model="payment.Description" placeholder="Açıklama"></textarea>
                    </div>
                </div>
                <template #modal-footer>
                    <v-executer :action="addPayment" :loading="savingPayment" :disabled="!canAddPayment">Ekle</v-executer>
                </template>
            </b-modal>
            <div class="row">
                <div class="col-12">
                    <ul class="list-group">
                        <li class="list-group-item">
                            <label class="form-label">Arabuluculuk Yapıldı Mı?</label>
                            <div>
                                <b-form-radio inline v-model="mediation.Applied" :value="true">Evet</b-form-radio>
                                <b-form-radio inline v-model="mediation.Applied" :value="false">Hayır</b-form-radio>
                            </div>
                        </li>
                        <template v-if="mediation.Applied == true">
                            <li class="list-group-item">
                                <label class="form-label">Anlaşma Sağlandı Mı?</label>
                                <div>
                                    <b-form-radio inline v-model="mediation.Agreed" :value="true">Evet</b-form-radio>
                                    <b-form-radio inline v-model="mediation.Agreed" :value="false">Hayır</b-form-radio>
                                </div>
                            </li>
                            <template v-if="mediation.Agreed == true">
                                <!--
                                    Tekil ödeme alanları (Ödeme Tarihi/Miktarı/Referans No) EKRANDAN KALDIRILDI.
                                    Ödemeler artık yalnızca aşağıdaki "Ödemeler" tablosundan (çoklu ödeme + ödeme
                                    yöntemi + çek no) yönetilir; Sterling banka gönderimi de yalnız o kayıtları okur.
                                    Backend alanları (SGKJobExitTask.ArabuluculukOdeme*) ve DB kolonları korunmuştur.
                                -->
                                <li class="list-group-item">
                                    <v-file-uploader :accept="['xlsx','rtf','pdf']" :value="mediation" value-parameter="File"></v-file-uploader>
                                </li>
                                <li class="list-group-item">
                                    <div class="d-flex justify-content-between align-items-center mb-1">
                                        <label class="form-label mb-0">Ödemeler</label>
                                        <button class="btn btn-primary btn-sm" v-on:click="openPaymentModal">Ödeme Ekle</button>
                                    </div>
                                    <div class="table-responsive">
                                        <table class="table table-sm bordered-header mb-0">
                                            <thead>
                                                <tr>
                                                    <th><feather-icon icon="MoreHorizontalIcon"></feather-icon></th>
                                                    <th>Ödeme Tarihi</th>
                                                    <th class="text-right">Tutar</th>
                                                    <th>Ödeme Yöntemi</th>
                                                    <th>Çek No</th>
                                                    <th>Referans No</th>
                                                    <th>Açıklama</th>
                                                    <th>Banka</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="p in payments" :key="p.Id">
                                                    <td>
                                                        <button v-if="!p.PaidDate" class="btn btn-flat-danger btn-sm btn-icon" v-on:click="deletePayment(p)">
                                                            <feather-icon icon="TrashIcon"></feather-icon>
                                                        </button>
                                                    </td>
                                                    <td>{{ p.PaymentDateStr }}</td>
                                                    <td class="text-right">{{ p.PaymentAmountStr }}</td>
                                                    <td>{{ p.PaymentMethodStr }}</td>
                                                    <td>{{ p.CheckNumber || '-' }}</td>
                                                    <td>{{ p.ReferenceNumber || '-' }}</td>
                                                    <td>{{ p.Description || '-' }}</td>
                                                    <td class="text-nowrap">
                                                        <b-badge v-if="p.PaidDate" variant="light-success">Ödendi · {{ p.PaidDateStr }}</b-badge>
                                                        <b-badge v-else-if="p.InSterling" variant="light-info">Banka dosyasında</b-badge>
                                                        <span v-else>-</span>
                                                    </td>
                                                </tr>
                                                <tr v-if="payments.length == 0">
                                                    <td colspan="1000" class="text-center">Henüz bir ödeme bulunmamaktadır.</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </li>
                            </template>
                            <template v-else-if="mediation.Agreed == false">
                                <li class="list-group-item">
                                    <label class="form-label text-secondary">Açıklama</label>
                                    <textarea class="form-control resize-none" rows="4" v-model="mediation.Description" placeholder="Açıklama"></textarea>
                                </li>
                            </template>
                        </template>
                    </ul>
    
                </div>
            </div>
            <div class="text-right mt-1">
                <button v-if="!hidePrev" class="btn btn-outline-secondary mr-1" v-on:click="$emit('prev-step')">Geri</button>
                <v-executer class="btn btn-warning btn-outline-warning mr-1" :loading="saving" text="Arabuluculuk Bilgilerini Güncelle" :action="saveMediation"></v-executer>
                <v-executer v-if="!hideComplete" class="btn btn-danger btn-outline-danger" :loading="completing" text="Çıkışı Tamamla" :action="completeExit"></v-executer>
            </div>
        </div>
    </b-overlay>
</template>

<script>
import VFileUploader from '@/components/v-file-uploader/VFileUploader.vue'
import { BFormRadio, BOverlay, BBadge } from 'bootstrap-vue'
import VCurrencyInput from '@/components/VCurrencyInput.vue'
import EmployeeOperationsApi from '@/api/employee-operations'
import Additional from '@/utilities/additional'

export default{
    components:{
        VFileUploader,
        BFormRadio,
        VCurrencyInput,
        EmployeeOperationsApi,
        BOverlay,
        BBadge
    },
    props:{
        id:[Number,String],
        taskId:[Number,String],
        // Yeni "Arabuluculuk" sayfasında çıkış zaten tamamlanmıştır; "Çıkışı Tamamla" ve
        // "Geri" (adım) butonları gizlenir. Çıkış akışında bu bileşen artık kullanılmıyor.
        hideComplete:Boolean,
        hidePrev:Boolean,
        // Çıkış akışında parent, kaydetme sonrası personel verisini tazelemek için geçerdi.
        // Ayrı Arabuluculuk sayfasında verilmez; bu yüzden opsiyoneldir.
        getPersonal:Function,
    },
    data(){
        return {
            getting:false,
            mediation:{
                ExitTaskId:null,
                Applied:null,
                Agreed:null,
                File:null,
                PaymentDeadline:null,
                PaymentAmount:null,
                Description:null,
                ReferenceNumber:null
            },
            saving:false,
            completing:false,
            payments:[],
            savingPayment:false,
            // Backend: MediationPaymentMethod (Nakit=0, Havale=1, Cek=2)
            paymentMethods:[
                {name:'Nakit',value:0},
                {name:'Havale/EFT',value:1},
                {name:'Çek',value:2},
            ],
            payment:{
                PaymentDate:null,
                PaymentAmount:null,
                PaymentMethod:0,
                CheckNumber:null,
                ReferenceNumber:null,
                Description:null
            }
        }
    },
    mounted(){
        this.get()
        this.getPayments()
    },
    methods:{
        get(){
            this.getting = true
            EmployeeOperationsApi.ArabuluculukInfo(this.taskId).then(res => {
                if(res.data.Success){
                    const d = res.data.Data
                    this.mediation.ExitTaskId = this.taskId
                    this.mediation.Applied = d.Arabuluculuk
                    this.mediation.Agreed = d.ArabuluculukAnlasma
                    this.mediation.PaymentDeadline = d.ArabuluculukOdemeTarihi
                    this.mediation.PaymentAmount = d.ArabuluculukOdemeMiktari
                    this.mediation.Description = d.Aciklama
                    this.mediation.ReferenceNumber = d.ArabuluculukRefNo
                }
                this.getting = false
            }).catch(err => {
                this.$result(null,err)
                this.getting = false
            })
        },
        async saveMediation(){
            this.saving = true
            this.mediation.ExitTaskId = this.taskId
            let formData = await Additional.ToFormData(this.mediation)
                EmployeeOperationsApi.Employee.UpdateArabuluculukInfo(formData)
                .then(res=>{
                    this.saving = false
                    this.$result(res)
                    // getPersonal yalnızca çıkış akışında parent'tan geçilir; ayrı Arabuluculuk
                    // sayfasında yoktur. Koşulsuz çağrı TypeError atıp kaydetme başarılı olsa bile
                    // "Bilinmeyen bir hata oluştu" toast'ı gösteriyordu.
                    if(res.data.Success && typeof this.getPersonal === 'function'){
                        this.getPersonal()
                    }
                }).catch(err=>{
                    this.$result(null,err)
                    this.saving = false
                })
        },
        getPayments(){
            EmployeeOperationsApi.ListMediationPayments(this.taskId).then(res => {
                if(res.data.Success) this.payments = res.data.Data || []
            }).catch(err => {
                this.$result(null,err)
            })
        },
        openPaymentModal(){
            this.payment = {
                PaymentDate:null,
                PaymentAmount:null,
                PaymentMethod:0,
                CheckNumber:null,
                ReferenceNumber:null,
                Description:null
            }
            this.$showModal('add-mediation-payment')
        },
        async addPayment(){
            this.savingPayment = true
            const body = { ...this.payment, ExitTaskId:this.taskId }
            // Çek dışındaki yöntemlerde çek numarası taşınmaz.
            if(body.PaymentMethod != 2) body.CheckNumber = null
            const formData = await Additional.ToFormData(body)
            return EmployeeOperationsApi.AddMediationPayment(formData).then(res => {
                this.savingPayment = false
                this.$result(res)
                if(res.data.Success){
                    this.$hideModal('add-mediation-payment')
                    this.getPayments()
                }
            }).catch(err => {
                this.savingPayment = false
                this.$result(null,err)
            })
        },
        deletePayment(p){
            this.$confirm('Ödemeyi Sil','Bu ödemeyi silmek istediğinize emin misiniz?').then(c => {
                if(!c) return
                EmployeeOperationsApi.DeleteMediationPayment(p.Id).then(res => {
                    this.$result(res)
                    if(res.data.Success) this.getPayments()
                }).catch(err => {
                    this.$result(null,err)
                })
            }).catch(()=>{})
        },
        completeExit(){
            return new Promise((resolve)=>{
                this.$confirm('Çıkışı Tamamla','Çıkış işlemini tamamlamak istediğinize emin misiniz?').then(c=>{
                    if(!c){ resolve(); return }
                    this.completing = true
                    EmployeeOperationsApi.CompleteExit(this.taskId).then(res=>{
                        this.completing = false
                        this.$result(res)
                        if(res.data.Success){
                            this.$emit('completed')
                        }
                        resolve()
                    }).catch(err=>{
                        this.completing = false
                        this.$result(null,err)
                        resolve()
                    })
                }).catch(()=>resolve())
            })
        }
    },
    computed:{
        // Çek seçiliyse çek numarası zorunlu (backend de aynı kuralı doğrular).
        canAddPayment(){
            if(this.payment.PaymentDate == null) return false
            if(!(this.payment.PaymentAmount > 0)) return false
            if(this.payment.PaymentMethod == 2 && !(this.payment.CheckNumber || '').trim()) return false
            return true
        }
    }
}
</script>